import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router';
import FilterTag from '@components/FilterTag';

const SelectedFiltersList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const query = searchParams.get('query');

  const onRemoveFilter = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams);
  };

  return (
    <Flex gap={2} mb={2} flexWrap="wrap">
      {query && (
        <FilterTag
          label="Nome"
          value={query}
          onRemove={() => onRemoveFilter('query')}
        />
      )}
    </Flex>
  );
};

export default SelectedFiltersList;
